import $ from "jquery";
import "../components/fade-slider";
import "../components/fade-slider-with-animation";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper from "swiper";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/effect-fade";
gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

mm.add("(min-width: 991px)", () => {
  $(".js-slider-photo-big").each(function () {
    const homePhotoBigTL = gsap.timeline({
      scrollTrigger: {
        trigger: $(this),
        start: "top 100%",
        end: "top 30%",
        scrub: true,
      },
    });
    homePhotoBigTL.from($(this), { x: 700 });
  });

  $(".js-slider-photo-small").each(function () {
    const homePhotoSmallTL = gsap.timeline({
      scrollTrigger: {
        trigger: $(this),
        start: "top 93%",
        end: "top 30%",
        scrub: true,
      },
    });
    homePhotoSmallTL.from($(this), { x: 50 });
  });
});

const firstLocationSlider = new Swiper(".location-first-slider .swiper", {
  loop: true,
  navigation: {
    nextEl: ".slider--next",
    prevEl: ".slider--prev",
  },
  slidesPerView: 1,
  spaceBetween: 30,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  speed: 1500,
});

const secondLocationSlider = new Swiper(".location-second-slider .swiper", {
  loop: true,
  navigation: {
    nextEl: ".slider--next",
    prevEl: ".slider--prev",
  },
  slidesPerView: 1,
  spaceBetween: 30,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  speed: 1500,
});

$(".location-first-slider .slider--next").on("click", function () {
  firstLocationSlider.slideNext();
});

$(".location-first-slider .slider--prev").on("click", function () {
  firstLocationSlider.slidePrev();
});

$(".location-second-slider .slider--next").on("click", function () {
  secondLocationSlider.slideNext();
});

$(".location-second-slider .slider--prev").on("click", function () {
  secondLocationSlider.slidePrev();
});
